'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _requestPath = require('./requestPath');

var _requestPath2 = _interopRequireDefault(_requestPath);

var _Error = require('../lib/Error');

var _Error2 = _interopRequireDefault(_Error);

var _sleep = require('../lib/sleep');

var _sleep2 = _interopRequireDefault(_sleep);

var _environment = require('../lib/environment');

var _environment2 = _interopRequireDefault(_environment);

var _environments = require('../config/environments');

var environmentType = _interopRequireWildcard(_environments);

var _logger = require('../logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOCK_DELAY = 1000;
var SUCCESS_CODE_LOWER_BOUND = 200;
var SUCCESS_CODE_HIGHER_BOUND = 300;
var TIMEOUT = 6000;

var GET = 'GET';
var POST = 'POST';

var TIMEOUT_ERROR = 'timeout-error';
var FETCH_ERROR = 'fetch-error';
var SERVER_ERROR = 'server-error';

/*eslint-disable*/
var sendRequest = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(config, options) {
        var response, _options$method, method, data, requestPath, fetchConfig, urlParsed;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        response = null;
                        _options$method = options.method, method = _options$method === undefined ? GET : _options$method, data = options.data, requestPath = options.url;


                        requestPath = (0, _requestPath2.default)(requestPath, config.host);
                        method = method.toUpperCase();

                        if (_environment2.default === environmentType.DEVELOPMENT) {
                            method = GET;
                        }

                        fetchConfig = (0, _extends3.default)({}, config);

                        delete fetchConfig.timeout;
                        delete fetchConfig.host;

                        _context.t0 = method;
                        _context.next = _context.t0 === GET ? 11 : _context.t0 === POST ? 17 : 21;
                        break;

                    case 11:
                        urlParsed = _url2.default.parse(requestPath, true);

                        requestPath = _url2.default.format((0, _extends3.default)({}, urlParsed, {
                            query: (0, _extends3.default)({}, urlParsed.query, data)
                        }));
                        _context.next = 15;
                        return (0, _isomorphicFetch2.default)(requestPath, (0, _extends3.default)({}, fetchConfig));

                    case 15:
                        response = _context.sent;
                        return _context.abrupt('break', 22);

                    case 17:
                        _context.next = 19;
                        return (0, _isomorphicFetch2.default)(requestPath, (0, _extends3.default)({}, fetchConfig, {
                            method: method,
                            body: (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' ? (0, _stringify2.default)(data) : data,
                            headers: (0, _extends3.default)({
                                Accept: 'application/json',
                                'Content-Type': 'application/json'
                            }, fetchConfig.headers)
                        }));

                    case 19:
                        response = _context.sent;
                        return _context.abrupt('break', 22);

                    case 21:
                        return _context.abrupt('break', 22);

                    case 22:
                        if (!(_environment2.default === environmentType.DEVELOPMENT)) {
                            _context.next = 25;
                            break;
                        }

                        _context.next = 25;
                        return (0, _sleep2.default)(MOCK_DELAY);

                    case 25:
                        return _context.abrupt('return', response);

                    case 26:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function sendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var timeoutPromise = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(fetchConfig, fetchOptions) {
        var _fetchConfig$timeout, timeout;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _fetchConfig$timeout = fetchConfig.timeout, timeout = _fetchConfig$timeout === undefined ? TIMEOUT : _fetchConfig$timeout;
                        _context2.next = 3;
                        return (0, _sleep2.default)(timeout);

                    case 3:
                        throw new _Error2.default('请求服务器超时', TIMEOUT_ERROR);

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function timeoutPromise(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var AmyFetch = function AmyFetch(fetchConfig) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(fetchOptions, componentName) {
            var response, resp;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _promise2.default.race([timeoutPromise(fetchConfig, fetchOptions), sendRequest(fetchConfig, fetchOptions)]);

                        case 3:
                            response = _context3.sent;

                            if (!(response.status < SUCCESS_CODE_LOWER_BOUND || response.status >= SUCCESS_CODE_HIGHER_BOUND)) {
                                _context3.next = 9;
                                break;
                            }

                            _logger2.default.error('fetchError', {
                                category: 'ajaxError',
                                tags: {
                                    request: (0, _extends3.default)({}, fetchConfig, fetchOptions),
                                    response: response
                                }
                            });
                            throw new _Error2.default(response, FETCH_ERROR);

                        case 9:
                            _context3.next = 11;
                            return response.json();

                        case 11:
                            resp = _context3.sent;
                            _context3.t0 = resp.code;
                            _context3.next = _context3.t0 === 0 ? 15 : _context3.t0 === 200 ? 15 : _context3.t0 === 400 ? 15 : 17;
                            break;

                        case 15:
                            return _context3.abrupt('return', resp.data);

                        case 17:
                            _logger2.default.error('serverError', {
                                category: 'ajaxError',
                                tags: {
                                    request: (0, _extends3.default)({}, fetchConfig, fetchOptions),
                                    response: response
                                }
                            });
                            throw new _Error2.default(resp, SERVER_ERROR);

                        case 19:
                            _context3.next = 25;
                            break;

                        case 21:
                            _context3.prev = 21;
                            _context3.t1 = _context3['catch'](0);

                            if (_context3.t1.name === TIMEOUT_ERROR) {
                                _logger2.default.error('timeoutError', {
                                    category: 'ajaxError',
                                    tags: {
                                        request: (0, _extends3.default)({}, fetchConfig, fetchOptions)
                                    }
                                });
                            }
                            throw _context3.t1;

                        case 25:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[0, 21]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var createFetch = function createFetch(config) {
    return AmyFetch(config || {});
};

var amyFetch = createFetch();

amyFetch.AmyFetch = AmyFetch;
amyFetch.create = createFetch;

exports.default = amyFetch;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/varyag-hoc-component/fetch/index.js
// module id = 154
// module chunks = 0